import { Close } from "icons";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrandAction } from "store/actions";

const PromotionalBanner = () => {
    const dispatch = useDispatch();
    const { brandInfo } = useSelector((state) => state?.brandStorageReducer);

    if (brandInfo?.setting?.promotionalBannerConfig?.showBanner) {
        document.body.style.overflow = "hidden";
    } else {
        document.body.style.overflow = "auto";
        return null;
    }

    return (
        <div className="w-full h-full fixed top-0 left-0 right-0  flex justify-center items-center" style={{ zIndex: 500 }}>
            <div className="max-460 bg-gray-500 bg-opacity-50 h-full w-full flex justify-center items-center">
                <div
                    style={{
                        // backdropFilter: "blur(10px)",
                        background: "transparent",
                        color: "black",
                        // boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",
                        borderRadius: "16px",
                        width: "95%",
                        height: "85vh",
                        position: "relative",
                        ...(brandInfo?.setting?.promotionalBannerConfig?.bannerType?.toLowerCase() ===
                            "image" && {
                            backgroundImage: `url(${brandInfo?.setting?.promotionalBannerConfig?.bannerUrl})`,
                            backgroundSize: "contain",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                        }),
                    }}
                >
                    <div
                        className="absolute z-50"
                        style={{
                            top: "calc(env(safe-area-inset-top, 0px) + 8px)",
                            right: "8px",
                        }}
                    >
                        <button
                            aria-label="Close promotional banner"
                            className="p-2 bg-black/40 rounded-full active:scale-95 transition"
                            onClick={() =>
                                dispatch(
                                    BrandAction.getbrandInfoSuccess({
                                        ...brandInfo,
                                        setting: {
                                            ...brandInfo?.setting,
                                            promotionalBannerConfig: {
                                                ...brandInfo?.setting?.promotionalBannerConfig,
                                                showBanner: false,
                                            },
                                        },
                                    })
                                )
                            }
                        >
                            <Close
                                className={`text-white group-hover:text-brand-base-primary transition-all duration-300 w-6 h-6`}
                            />
                        </button>
                    </div>
                    {(brandInfo?.setting?.promotionalBannerConfig?.bannerText ||
                        brandInfo?.setting?.promotionalBannerConfig?.bannerDescriptions) ? (
                        <div
                            className="absolute bottom-0 left-0 z-50 w-full flex flex-col gap-4
    bg-white/20 backdrop-blur-md border border-white/30 rounded-16x shadow-xl p-4"
                        >
                            <div className="text-white text-16x font-bold drop-shadow-md">
                                {brandInfo?.setting?.promotionalBannerConfig?.bannerText}
                            </div>

                            <p className="text-white text-12z font-bold drop-shadow-md">
                                {
                                    brandInfo?.setting?.promotionalBannerConfig
                                        ?.bannerDescriptions
                                }
                            </p>
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default PromotionalBanner;
